import React from "react";
import { FormRow } from "../../components";
import { type GetSetValueProp, timeOptions } from "../models";
import BaseReactSelectDropdown from "components/dropdowns/reactselect/BaseReactSelectDropdown";

const UpcomingShowsDropdown = (props: GetSetValueProp<number>) => <FormRow label={RESX.EmbedWizard.UpcomingShows}>
  <BaseReactSelectDropdown
    excludeKeys={[]}
    options={timeOptions}
    value={timeOptions.find(o => o.value === props.value)}
    onChange={v => { props.setValue(v.value); }}
    config={{}}
    getLabel={o => o.text}
    getValue={o => o.value}
  />
</FormRow>;

export default UpcomingShowsDropdown;
